import { IDictionary } from '../types';

const refreshTimes: IDictionary<number | null> = {
  super_fast: 15000,
  fast: 30000,
  medium: 60000,
  slow: 180000,
  super_slow: 600000,
  never: null,
};

export default refreshTimes;
